import { DeviceEnabledType, UserAttributeDefs } from '@iotv/datamodel-core'
import { DeepPartial, getEnumShape, Position } from '@iotv/iotv-v3-types'

const typeName = 'Pump'
const PUMP_TYPES: string[] = ['Single Relay', 'Double Relay']
export const PumpTypeEnum = getEnumShape(PUMP_TYPES)

export type PumpDownLinkControlObjectType = {
  pumpControlRelay1: boolean
  pumpControlRelay2: boolean
}

export type PumpProps = {
  location?: Position
  pumpType: string // pump type @ref PUMP_TYPES
  pumpOnOff: boolean // if the pump is on or not
  pumpControl: number // Unsure what it is, may be deletable
}

export class Pump extends DeviceEnabledType implements PumpProps {
  constructor(ob: any) {
    super(ob.type || typeName, ob)
    this.pumpOnOff = ob.pumpOnOff ?? false
    this.pumpControl = ob.pumpControl ?? 10
    this.pumpType = ob.pumpType
  }

  // state?: string;
  location?: Position
  pumpOnOff: boolean
  pumpType: string

  pumpControl: number

  /**
   * The turnOn function returns an array, as double relays require two payloads to turn on the device.
   * This is done as assuming there is an array of actions to do is easier, as compared to checking if the output is an array or not
   */
  turnOnPump(): DeepPartial<PumpDownLinkControlObjectType>[] | null {
    if (this.pumpType) {
      switch (this.pumpType) {
        case 'Single Relay':
          return [
            {
              pumpControlRelay1: true,
            },
          ]
        case 'Double Relay':
          return [
            {
              pumpControlRelay1: true,
            },
            {
              pumpControlRelay1: false,
            },
          ]
      }
    }

    return null
  }

  /**
   * The turnOff function returns an array, as double relays require two payloads to turn on the device.
   * This is done as assuming there is an array of actions to do is easier, as compared to checking if the output is an array or not
   */
  turnOffPump(): DeepPartial<PumpDownLinkControlObjectType>[] | null {
    if (this.pumpType) {
      switch (this.pumpType) {
        case 'Single Relay':
          return [
            {
              pumpControlRelay1: false,
            },
          ]
        case 'Double Relay':
          return [
            {
              pumpControlRelay2: true,
            },
            {
              pumpControlRelay2: false,
            },
          ]
      }
    }

    return null
  }

  getUserAttributes(): UserAttributeDefs {
    return {
      ...super.getUserAttributes(),
      name: {
        type: 'String',
        editable: true,
        required: true,
        label: 'Name',
        name: 'name',
        description: 'Name of Water Flow Meter',
      },
      pumpType: { type: 'Enum', editable: true, required: true, label: 'Pump Type', description: 'Pump Type', enumKv: PumpTypeEnum },

      pumpOnOff: {
        type: 'Boolean',
        editable: false,
        label: 'Active Pump',
        name: 'Active Pump',
        description: 'Is the pump active',
      },

      comments: {
        type: 'String',
        editable: true,
        label: 'Comments',
        name: 'comments',
        description: 'Free text for info ',
      },
    }
  }
}
